export const validateCPF = (e) => {
  if (!e) return false;
  let dig = e.match(/\d/g).map((d) => parseInt(d));
  let dv = [
    ((dig
      ?.slice(0, 9)
      .map((n, i) => n * (10 - i))
      .reduce((_, e) => _ + e) *
      10) %
      11) %
      10,
    ((dig
      ?.slice(0, 10)
      .map((n, i) => n * (11 - i))
      .reduce((_, e) => _ + e) *
      10) %
      11) %
      10,
  ];
  let rep = !dig
    ?.slice(0, 9)
    .map((e, i, l) => e === l[0])
    .reduce((_, e) => _ && e);

  return dig[9] === dv[0] && dig[10] === dv[1] && rep;
};

export const validateNumber = (num) => {
  let v = parseInt(num);
  if (isNaN(v)) {
    return false;
  }
  return true;
};

export const validarCNPJ = (cnpj) => {
  if (!cnpj) return false;
  if (cnpj.length === 18) {
    cnpj = cnpj.trim();
    cnpj = cnpj.replace(/\./g, "");
    cnpj = cnpj.replace("-", "");
    cnpj = cnpj.replace("/", "");
    cnpj = cnpj.split("");
  } else {
    return false;
  }
  if (cnpj.length !== 14) return false;
  let v1 = 0;
  let v2 = 0;
  let aux = false;

  for (let i = 1; cnpj.length > i; i++) {
    if (cnpj[i - 1] !== cnpj[i]) {
      aux = true;
    }
  }

  if (aux === false) {
    return false;
  }
  for (let i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
    if (p1 >= 2) {
      v1 += cnpj[i] * p1;
    } else {
      v1 += cnpj[i] * p2;
    }
  }

  v1 = v1 % 11;
  if (v1 < 2) {
    v1 = 0;
  } else {
    v1 = 11 - v1;
  }
  if (v1 !== parseInt(cnpj[12])) {
    return false;
  }
  for (let i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
    if (p1 >= 2) {
      v2 += cnpj[i] * p1;
    } else {
      v2 += cnpj[i] * p2;
    }
  }

  v2 = v2 % 11;

  if (v2 < 2) {
    v2 = 0;
  } else {
    v2 = 11 - v2;
  }

  if (v2 !== parseInt(cnpj[13])) {
    return false;
  } else {
    return true;
  }
};
